import { createStore } from 'reusable';
import { useSearchParams } from 'react-router-dom';
import type { QueryParams } from '../constants/QueryParams';

export const useQueryParams = createStore(() => {
  const [searchParams, setSearchParams] = useSearchParams();

  const getParam = (paramName: string) => searchParams.get(paramName);
  const setParam = (paramName: string, paramValue: string) => {
    searchParams.set(paramName, paramValue);
    setSearchParams(searchParams);
  };
  const removeParam = (paramName: QueryParams) => {
    if (searchParams.has(paramName)) {
      searchParams.delete(paramName);
      setSearchParams(searchParams);
    }
  };
  return { getParam, setParam, removeParam };
});
